import React from "react";
import "../styles/components/ConfirmationModal.css";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  onCancel,
  showCancelButton = true,
  message = "Are you sure?",
  confirmText = "Yes",
  cancelText = "No",
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={handleOverlayClick}>
      <div className="confirm-modal-content" role="dialog" aria-modal="true">
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-buttons">
          <button
            className="confirm-modal-button confirm-modal-confirm"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
          {showCancelButton && (
            <button
              className="confirm-modal-button confirm-modal-cancel"
              onClick={onCancel || onClose}
            >
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
